import api from '../api';

export const getProjects = () => {
  return api.get('/company/v2/projects', {
    // Explicitly set the role here
    role: 'company'
  });
};

export const createProject = (data) => {
  return api.post('/company/v2/projects', data , {
    role: 'company'
  });
};